import * as React from "react";
import { useFolderMutations } from "../../../../hooks";
import { FolderFormDialog } from "./FolderFormDialog";

interface AddFolderDialogProps {
  isOpen: boolean;
  onClose: () => void;
  organizationId: number;
}

export function AddFolderDialog(props: AddFolderDialogProps) {
  const { isOpen, onClose, organizationId } = props;

  const { createFolderAsync, isCreating } = useFolderMutations(organizationId);

  const handleSubmit = async (name: string) => {
    try {
      await createFolderAsync({
        name,
        user_ids: [],
        group_ids: [],
      });
      onClose();
    } catch (error) {
      // Error already shown via toast
      // Dialog stays open so user can retry
    }
  };

  return (
    <FolderFormDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Add Folder"
      onSubmit={handleSubmit}
      isLoading={isCreating}
      loadingText="Creating..."
      submitText="Create"
    />
  );
}
